/**
 * This is the status as reported by the Jupyter frame.
 *
 * @remarks
 * Each of the statuses here represent mutually exclusive states in the Jupyter frame load lifecycle.
 */
export const enum JupyterStatus {
  /** Only used for sessionless editing to distinguish true init from disconnected Jupyter kernel state. */
  IDLE = "IDLE",
  /** The jupyter frame hasn't initialized yet. Jupyter frame is not loaded. The default state. */
  DISCONNECTED = "DISCONNECTED",
  /** Our custom code has been hit and we are waiting on Jupyter to initialize. */
  INITIALIZING = "INITIALIZING",
  /** The jupyter frame has initialized but is not fully loaded. It now has a communications channel to the parent. */
  INITIALIZED = "INITIALIZED",
  /** The jupyter frame has loaded and our custom components are bootstrapping. */
  LOADED = "LOADED",
  /** The jupyter frame is ready for commands. */
  RUNNING = "RUNNING",
  /** Only used for sessionless editing for the connected backend kernel state. */
  CONNECTED = "CONNECTED",
}
